import { generateUUID, isEmpty } from 'mc-ui-utils';
import State from '../state';
import { getNetworkType, getStartSource } from '../utils/khazaddumbridge';
import BaseEvent from './BaseEvent';
import highlightEvent, { SessionMode } from './HighlightEvent';
export default class ImpressionEvent extends BaseEvent {
    constructor(glanceId, bubbleImpressionId, position) {
        super();
        this.ctaEvent = null;
        this.videoEvent = null;
        this.shareEvent = null;
        this.likeEvent = null;
        this.bubbleImpressionid = null;
        this.glanceDuration = null; // amount of time glance was seen
        this.glanceStartSource = null;
        this.glanceEndSource = null;
        this.glanceHoldDuration = null; // amount of time glance was on hold
        this.gId = null; // glance Id
        this.glanceImpressionId = null;
        this.glanceImpressionType = 'bubble';
        this.isOfflinePeek = false;
        this.peekSource = null;
        this.networkType = null;
        this.glancePosition = null;
        this.highlightsSessionId = highlightEvent.highlightsSessionId;
        this.glanceStartedTime = null;
        this.moreOptionTapCount = 0;
        this.moreOptionTapTime = null;
        /*** at Android activity level, hence ignored **/
        this.activitySessionId = null;
        /** deprecated **/
        this.isStreaming = null;
        this.stickerCount = null;
        this.streamDuration = null;
        this.isFeatureBank = false;
        this.isHolding = false;
        this.eventName = "glance_impression" /* IMPRESSION */;
        this.bubbleImpressionid = bubbleImpressionId;
        this.gId = glanceId;
        this.glanceImpressionId = generateUUID();
        State.impressionMap[glanceId] = this.glanceImpressionId;
        this.glancePosition = position;
        this.peekSource = highlightEvent.peekSource;
    }
    setShown() {
        this.glanceStartedTime = Date.now();
        State.currentGlanceId = this.gId;
        State.currentImpressionId = this.glanceImpressionId;
    }
    /****
     *
     * Called soon after a event is fired
     *
     */
    reset() {
        this.isHolding = false;
        this.moreOptionTapCount = 0;
        this.moreOptionTapTime = null;
        this.glanceHoldDuration = null;
        this.glanceStartSource = null;
        this.glanceEndSource = null;
        this.ctaEvent = null;
        this.videoEvent = null;
        this.shareEvent = null;
        this.likeEvent = null;
        this.glanceStartedTime = null;
    }
    setIsHolding() {
        this.isHolding = Date.now();
    }
    setFinishedHolding() {
        const holdDuration = Date.now() - this.isHolding;
        this.glanceHoldDuration = holdDuration;
        this.isHolding = false;
    }
    setMoreOptions() {
        this.moreOptionTapCount += 1;
        if (isEmpty(this.moreOptionTapTime)) {
            this.moreOptionTapTime = Date.now();
        }
    }
    setFinished(source) {
        this.glanceEndSource = source;
    }
    setStart(source) {
        if (!isEmpty(source)) {
            this.glanceStartSource = source;
        }
        else {
            if (!isEmpty(State.lastPageChangeSource)) {
                this.glanceStartSource = State.lastPageChangeSource;
            }
            else {
                this.glanceStartSource = getStartSource();
            }
        }
    }
    /****
     *  Below functions are disabled, due to an SDK bug where the nested fields are causing exceptions
     * will need to be enabled once SDK fixes it
     *
     */
    setCTADetails(duration, failureCount, loadTime, ctaTime) {
        const ctaEvent = {
            ctaDuration: duration,
            ctaFailureCount: failureCount,
            ctaLoadDuration: loadTime,
            ctaTapCount: !isEmpty(this.ctaEvent) ? this.ctaEvent.ctaTapCount + 1 : 1,
            ctaTime,
        };
        this.ctaEvent = ctaEvent;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setVideoDetails(videoEvent) {
        this.videoEvent = Object.assign(Object.assign({}, videoEvent), { videoHoldDuration: !isEmpty(this.glanceHoldDuration)
                ? this.glanceHoldDuration
                : 0 });
        // this.videoEvent = null;
    }
    setLikeDetails(likeState) {
        this.likeEvent = {
            likeState,
            likeTime: Date.now(),
            likeTapCount: isEmpty(this.likeEvent)
                ? 1
                : this.likeEvent.likeTapCount + 1,
            likeSource: SessionMode.HIGHLIGHTS,
        };
    }
    setShareDetails(shareSource) {
        this.shareEvent = {
            shareCount: isEmpty(this.shareEvent) ? 1 : this.shareEvent.shareCount + 1,
            shareSource,
            shareTime: Date.now(),
        };
    }
    toJSON() {
        let glanceHoldDuration = this.glanceHoldDuration;
        const endTime = Date.now();
        if (this.isHolding) {
            glanceHoldDuration = endTime - this.isHolding;
        }
        const glanceDuration = !isEmpty(this.glanceStartedTime)
            ? endTime - this.glanceStartedTime
            : 500; // some edge case where the glanceStartedTime is not being set, so defaulting to 500ms
        const analyticsEvents = Object.assign(Object.assign(Object.assign(Object.assign({}, this.ctaEvent), this.videoEvent), this.shareEvent), this.likeEvent);
        return Object.assign({
            bubbleImpressionid: this.bubbleImpressionid,
            glanceDuration,
            glanceStartSource: this.glanceStartSource,
            glanceEndSource: this.glanceEndSource,
            glanceHoldDuration,
            gId: this.gId,
            glanceImpressionId: this.glanceImpressionId,
            glanceImpressionType: this.glanceImpressionType,
            isOfflinePeek: false,
            peekSource: this.peekSource,
            networkType: getNetworkType(),
            glancePosition: this.glancePosition,
            highlightsSessionId: this.highlightsSessionId,
            activitySessionId: this.activitySessionId,
            sessionMode: "HIGHLIGHTS" /* HIGHLIGHTS */,
            glanceStartedTime: this.glanceStartedTime,
            stickerCount: null,
            streamDuration: null,
            moreOptionTapCount: this.moreOptionTapCount,
            moreOptionTapTime: this.moreOptionTapTime,
            isStreaming: false,
            isFeatureBank: false,
            eventName: this.eventName,
            customExtras: {
                pwaVersion: `PWA_${process.env.VERSION}`,
            },
        }, analyticsEvents);
    }
}
//# sourceMappingURL=ImpressionEvent.js.map